export const historyVendorMock = [
  {
    date: "21 Mar - Ore 09.15",
    fileRecords: 120,
    importedRecords: 118,
    errorRecords: 2,
    ecommerce: "Mediaworld",
  },
  {
    date: "20 Mar - Ore 18.45",
    fileRecords: 80,
    importedRecords: 80,
    errorRecords: 0,
    ecommerce: "Unieuro",
  },
  {
    date: "19 Mar - Ore 11.05",
    fileRecords: 150,
    importedRecords: 147,
    errorRecords: 3,
    ecommerce: "Euronics",
  },
  {
    date: "18 Mar - Ore 16.20",
    fileRecords: 60,
    importedRecords: 55,
    errorRecords: 5,
    ecommerce: "Expert",
  },
  {
    date: "17 Mar - Ore 10.00",
    fileRecords: 95,
    importedRecords: 95,
    errorRecords: 0,
    ecommerce: "Trony",
  },
];

